import { render, staticRenderFns } from "./agent-count-list.dialog.vue?vue&type=template&id=230bec27&scoped=true"
import script from "./agent-count-list.dialog.vue?vue&type=script&lang=js"
export * from "./agent-count-list.dialog.vue?vue&type=script&lang=js"
import style0 from "./agent-count-list.dialog.vue?vue&type=style&index=0&id=230bec27&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.16_babel-core@7.0.0-bridge.0_@babel+core@7.27._f767d633ff263e3cf51932694db5e4d0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "230bec27",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/front/game-platform-web/node_modules/.pnpm/vue-hot-reload-api@2.3.4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('230bec27')) {
      api.createRecord('230bec27', component.options)
    } else {
      api.reload('230bec27', component.options)
    }
    module.hot.accept("./agent-count-list.dialog.vue?vue&type=template&id=230bec27&scoped=true", function () {
      api.rerender('230bec27', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/admin/agent/components/agent-count-list.dialog.vue"
export default component.exports